import React, {ChangeEvent, useEffect, useRef, useState} from "react";
import styles from "../POIList/POIList.module.css";
import {
    DefaultButton,
    PrimaryButton,
    Dialog,
    DialogType,
    DialogFooter, MessageBarType,
} from "@fluentui/react";
import strings from "../../../loc/strings";
import {bulkUpload, bulkUploadHist} from "../../../services/ManageSystemServices/BulkUploadService";
import {useAuth} from "react-oidc-context";
import {displayMessageBar} from "../../LayoutWithAuth/LayoutWithAuth";

function BulkUploadDialog(props: any) {

    const auth = useAuth();
    const isHistoricalPeriodEnded = props.isHistoricalPeriodEnded;

    const dialogContentPropsEdit = {
        type: DialogType.normal,
        title: props.title,
    };

    const modalPropsEdit = React.useMemo(
        () => ({
            isBlocking: true,
        }),
        [],
    );

    const handleDialogCloseBulk = () => {
        props.setDialogIsHiddenBulk(true);
        setFile(undefined);
        if(inputFile.current?.value) {
            inputFile.current.value = "";
        }
        setFileHist(undefined);
        if(inputFileHist.current?.value) {
            inputFileHist.current.value = "";
        }
    };

    const [file, setFile] = useState<File | undefined>(undefined);
    const [fileHist, setFileHist] = useState<File | undefined>(undefined);

    const inputFile = useRef<HTMLInputElement | null>(null);
    const onClickAddFiles = () => {
        // current` points to the mounted file input element
        inputFile.current?.click();
    };
    const inputFileHist = useRef<HTMLInputElement | null>(null);
    const onClickAddFilesHist = () => {
        // current` points to the mounted file input element
        inputFileHist.current?.click();
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
            setFileHist(undefined);
        }
    };

    const handleFileHistChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setFile(undefined)
            setFileHist(e.target.files[0]);
        }
    };

    const uploadButtonClick = () => {
        if(file) {
            displayMessageBar(MessageBarType.info, "Uploading the file", true);
            bulkUpload(file, auth.user?.id_token,auth.user?.profile.name)
                .then(() => {
                    displayMessageBar(MessageBarType.success, "File was uploaded and the processing will start soon! You will shortly receive an email with the relevant details.", false);
                })
                .catch((error)=> {
                    displayMessageBar(MessageBarType.error, error.message, false);
                })
                .finally(() => {
                    handleDialogCloseBulk();
                });
        } else if(fileHist && !isHistoricalPeriodEnded) {
            displayMessageBar(MessageBarType.info, "Uploading the file", true);
            bulkUploadHist(fileHist, auth.user?.id_token,auth.user?.profile.name)
                .then(() => {
                    displayMessageBar(MessageBarType.success, "File was uploaded and the processing will start soon! You will shortly receive an email with the relevant details.", false);
                })
                .catch((error)=> {
                    displayMessageBar(MessageBarType.error, error.message, false);
                })
                .finally(() => {
                    handleDialogCloseBulk();
                });
        }
    }

    return (
        <div className="BulkUpload">
            <Dialog
                hidden={props.dialogIsHiddenBulk}
                onDismiss={handleDialogCloseBulk}
                dialogContentProps={dialogContentPropsEdit}
                modalProps={modalPropsEdit}
                maxWidth="560px"
            >
                { !isHistoricalPeriodEnded ?
                    <p>1. Download the zip file that includes the <a href="/documents/Import_Data_templates.7z">{strings.POIListTemplatesFileLink}</a> for historical and non-historical data.</p>
                :
                    <p>1. Download the <a href={"/documents/Import_Data_templates-Non_Historical.7z"}>{strings.POIListTemplateFileLink}</a> for non-historical data.</p>
                }

                <p>2. Locate in your PC, the CSV file that you wish to upload.</p>
                <input type='file'
                       id='file'
                       accept={".csv"}
                       ref={inputFile}
                       style={{ display: 'none' }}
                       data-testid="normal-file"
                       onChange={handleFileChange}
                />
                {!isHistoricalPeriodEnded && (
                    <input type='file'
                           id='file_hist'
                           accept={".csv"}
                           ref={inputFileHist}
                           style={{ display: 'none' }}
                           data-testid="historical-file"
                           onChange={handleFileHistChange}
                    />
                )}
                <DefaultButton text={strings.POIListFileLabel}
                               onClick={onClickAddFiles}
                               className={styles.buttonUpload}
                />
                {!isHistoricalPeriodEnded && (
                    <DefaultButton text={strings.POIListFileHistLabel}
                                   onClick={onClickAddFilesHist}
                                   className={styles.buttonUpload}
                    />
                )}
                <DialogFooter>
                    <PrimaryButton
                        text="Upload"
                        disabled={!(file || (!isHistoricalPeriodEnded && fileHist))}
                        onClick={uploadButtonClick}
                    />
                    <DefaultButton onClick={handleDialogCloseBulk} text="Cancel" />
                </DialogFooter>
            </Dialog>
        </div>
    );
}

export default BulkUploadDialog;